import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-under-development',
  templateUrl: './under-development.component.html',
  styleUrls: ['./under-development.component.css']
})
export class UnderDevelopmentComponent {
  constructor(private readonly router: Router) { }

  backToHome(): void {
    this.router.navigate(['/Home']);
  }

  refreshPage(): void {
    window.location.reload();
  }
}
